import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useListContext } from 'react-admin';
import { FormProvider } from 'react-hook-form';
import { FilterBar, FilterBarActions, FilterBarRow } from 'shared/mui/Filter/FilterBar';
import { FilterApplyButton, FilterResetButton } from 'shared/mui/Filter/FilterButtons';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { useSyncFilter } from 'shared/mui/Filter/hooks/useSyncFilter';
import { AutocompleteInput, TextInput } from 'shared/react-admin/Inputs';

type CompaniesFilterValues = {
  name: string;
  archive: boolean | null;
};

const DEFAULT_VALUES: CompaniesFilterValues = { name: '', archive: false };

export const CompaniesListFilter: React.FC = () => {
  const translate = useTypedTranslate();
  const { filterValues } = useListContext();

  const { form, onReset, onSubmit, appliedFilters } = useFilters<CompaniesFilterValues>({
    defaultValues: { ...DEFAULT_VALUES, ...filterValues },
    resetValues: DEFAULT_VALUES,
  });

  useSyncFilter<CompaniesFilterValues>({ appliedFilters });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FilterBar>
          <FilterBarRow sx={{ gridTemplateColumns: '1fr 1fr 272px' }}>
            <TextInput
              helperText={false}
              label={translate('app.filter.name')}
              name="name"
              source="name"
              sx={{ marginBottom: 0 }}
              variant="outlined"
            />
            <AutocompleteInput
              choices={[
                { id: true, name: translate('app.statuses.archive') },
                { id: false, name: translate('app.companies.activeStatus') },
              ]}
              helperText={false}
              label={translate('app.filter.status')}
              name="archive"
              source="archive"
              variant="outlined"
            />
            <FilterBarActions>
              <FilterResetButton onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterBarActions>
          </FilterBarRow>
        </FilterBar>
      </form>
    </FormProvider>
  );
};
